import React from 'react';
import { generateContent } from '../../helpers/plunger';

const NOW = new Date().getTime();
const week = 604800 * 1000; // Number of seconds in a week.
const fourWeeksFromNow = NOW + week * 4;

const ListItem = props => {
  const { columns, menu } = props;

  return <tr className="table__tr">{renderColumns(menu, columns)}</tr>;
};

const renderColumns = (data, columns) => {
  return columns.map((specs, i) => renderColumn(data, specs, i));
};

const renderColumn = (data, specs, i) => {
  const classes = `p table__td ${specs.class || ''}`;

  // if there's no prop, return empty
  if (!specs.link && !specs.raw && !data)
    return <td key={i} className={classes}></td>;

  let content = generateContent(data, specs);

  // NOTE: This is not ideal... I do not recommend this.

  if (specs.link && specs.link.label === 'Select Menu') {
    let date = new Date(data.date);
    let time = date.getTime();
    if (time > fourWeeksFromNow) content = null;
  }

  // END NOTE:

  return (
    <td key={i} className={classes}>
      {content}
    </td>
  );
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/shared/ListItem.js